import {
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

export const FileUploadInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    if (request.body instanceof Blob && request.body.type) {
        request = request.clone({
            headers: request.headers.set('Content-Type', request.body.type),
        });
    }

    return next(request);
};
